<template>
  <slot v-if="prefersReducedMotion" />
  <transition
    v-else
    name="expand"
    @after-enter="afterEnter"
    @enter="enter"
    @leave="leave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  emits: ['after-enter'],
  computed: {
    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion)')?.matches
    },
  },
  methods: {
    // lovingly copied from https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/
    afterEnter(element) {
      element.style.height = 'auto'
      this.$emit('after-enter')
    },
    enter(element) {
      const width = getComputedStyle(element).width

      element.style.width = width
      element.style.visibility = 'hidden'
      element.style.height = 'auto'

      const height = getComputedStyle(element).height

      element.style.visibility = null
      element.style.height = 0

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        element.style.height = height
      })
    },
    leave(element) {
      const height = getComputedStyle(element).height

      element.style.height = height

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height

      requestAnimationFrame(() => {
        element.style.height = 0
      })
    },
  },
}
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.expand-enter,
.expand-leave-active {
  opacity: 0;
}
</style>
